import { type FC, type PropsWithChildren } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { GripHorizontal } from 'lucide-react';
import { CSS } from '@dnd-kit/utilities';
import { useSortableFlag } from '@/components/inspector/entity-fields/form/sortable-flag-contex';
import { cn } from '@/lib/utils';

export const OptionItem: FC<PropsWithChildren & { optionKey: string; className?: string }> = ({
  optionKey,
  className,
  children,
}) => {
  const sortable = useSortableFlag();

  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: optionKey,
    disabled: !sortable,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      key={optionKey}
      className={cn('flex flex-col justify-center gap-2 px-3', className)}
      {...(sortable && { ref: setNodeRef, style: style })}
    >
      <div className="flex w-full items-center gap-2">
        <div className="flex min-w-0 grow items-center gap-2">
          {sortable && (
            <GripHorizontal className="icon-5 text-[#333333] outline-hidden" {...attributes} {...listeners} />
          )}
          {children}
        </div>
      </div>
    </div>
  );
};
